"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderLocationLog = exports.RiderLocationLogStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Log_1 = require("./Log");
exports.RiderLocationLogStruct = (0, superstruct_1.assign)(Log_1.LogStruct, (0, superstruct_1.type)({ update: (0, superstruct_1.object)() }));
function isRiderLocationLog(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.RiderLocationLogStruct, "RiderLocationLog");
}
exports.isRiderLocationLog = isRiderLocationLog;
